import {createAsyncThunk} from "@reduxjs/toolkit";
import type {DeletePosterFromEventAjaxParams, DeleteSocialPostFromEventAjaxParams, FetchEventPromotionResponse, PromotionStepAjaxParams, PromotionSteps} from "@Components/mystuff-event-promotion-page/mystuff-event-promotion-page.types";
import type {EventHashedID} from "@Components/events/events.types";

export const getEventPromotionInfo = createAsyncThunk<FetchEventPromotionResponse, EventHashedID>('getEventPromotionInfo', (eventHashedID: EventHashedID) => {
    return window.PMW.readLocal('event/getEventPromotionInfo', {event_hid: eventHashedID});
});

/** Re-reads only the steps, for a quiet refresh: no loader, no other list replaced. */
export const refreshEventPromotionSteps = createAsyncThunk<PromotionSteps, EventHashedID>('refreshEventPromotionSteps', async (eventHashedID: EventHashedID) => {
    const response = (await window.PMW.readLocal('event/getEventPromotionInfo', {event_hid: eventHashedID})) as FetchEventPromotionResponse;
    return response.promotionSteps;
});

export const markPromotionStepAsCompleted = createAsyncThunk('markPromotionStepCompleted', (params: PromotionStepAjaxParams) => {
    return window.PMW.writeLocal('event/markPromotionStepAsCompletedForEvent', {
        event_hid: params.eventHashedID,
        promotion_type: params.promotionType
    });
});

export const markPromotionStepAsSkipped = createAsyncThunk('markPromotionStepSkipped', (params: PromotionStepAjaxParams) => {
    return window.PMW.writeLocal('event/markPromotionStepAsSkippedForEvent', {
        event_hid: params.eventHashedID,
        promotion_type: params.promotionType
    });
});

export const deletePrintFlyerPoster = createAsyncThunk('deletePrintFlyerPoster', (params: DeletePosterFromEventAjaxParams) => {
    return window.PMW.writeLocal('event/deletePosterLinkedToEvent', {
        event_hid: params.eventHashedID,
        poster_hid: params.posterHashedId
    });
});

export const deleteSocialPostFromEvent = createAsyncThunk('deleteSocialPostFromEvent', (params: DeleteSocialPostFromEventAjaxParams) => {
    return window.PMW.writeLocal('event/deleteSocialPostLinkedWithEvent', {
        event_hid: params.eventHashedID,
        socialPostId: params.socialPostId
    });
});